module.exports = __webpack_public_path__ + "img/colored-paper-16.920c8aa9.png";